import { render, staticRenderFns } from "./PaginationCom.vue?vue&type=template&id=0a29739e&"
import script from "./PaginationCom.vue?vue&type=script&lang=js&"
export * from "./PaginationCom.vue?vue&type=script&lang=js&"
import style0 from "./PaginationCom.vue?vue&type=style&index=0&id=0a29739e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports